import { render, staticRenderFns } from "./DataTableWrapper.vue?vue&type=template&id=452ba62d"
import script from "./DataTableWrapper.vue?vue&type=script&lang=js"
export * from "./DataTableWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports